<!--  -->
<template>
  <div class="con">
    <div :class="isMobile ? 'lunbo' : ''">
      <el-carousel>
        <el-carousel-item v-for="(item, index) in imgs" :key="index">
          <img class="lunimg" :src="item.img" alt />
        </el-carousel-item>
      </el-carousel>
    </div>
    <transition
      name="fade"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
    >
      <div class="book" v-if="show">
        <div class="book_top">
          <div class="fz30">著作展示</div>
          <div class="fz14">— SERVICE —</div>
        </div>
        <div class="book_floot" v-if="!isMobile">
          <div class="lis" @click="goroute(1)">
            <div class="liimg">
              <img src="../assets/p1.png" alt />
            </div>
            <div class="title">医学影像数字化技术（Ⅰ）</div>

            <p class="ptitle">
              国际上广泛应用于医院影像数字化的PACS/RIS系统，
              它能全面、有效地解决医学影像的获取、
              显示、管理、存储和传输等一系列技术问题。
            </p>
          </div>
          <div class="lis" @click="goroute(2)">
            <div class="liimg">
              <img src="../assets/p2.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅱ）</div>

            <p class="ptitle">
              正在我国医院推广并普及的图像归档和传输系统PACS/放射医学信息系统RIS能全面、
              有效地解决医学影像的获取、显示、管理、存储和传输等一系列技术问题，
              为此所编写的“医院信息化技术（II）”
            </p>
          </div>
          <div class="lis" @click="goroute(3)">
            <div class="liimg">
              <img src="../assets/p3.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅲ）</div>

            <p class="ptitle">
              远程医学信息会诊系统是信息技术与医学相结合的产物，
              它运用网络通信与计算机多媒体技术为患者提供医学信息和医疗服务。
            </p>
          </div>
          <div class="lis" @click="goroute(4)">
            <div class="liimg">
              <img src="../assets/p4.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅳ）</div>

            <p class="ptitle">
              信息，指音讯、消息、通讯系统和处理的对象，
              泛指人类社会传播的一切内容。
            </p>
          </div>
        </div>
      </div>
    </transition>
    <div class="bookzhu" v-if="isMobile">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item>
          <div class="lis" @click="goroute(1)">
            <div class="imbook">
              <img src="../assets/p1.png" alt />
            </div>
            <div class="title">医学影像数字化技术（Ⅰ）</div>

            <p class="ptitle">
              国际上广泛应用于医院影像数字化的PACS/RIS系统，
              它能全面、有效地解决医学影像的获取、
              显示、管理、存储和传输等一系列技术问题。
            </p>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="lis" @click="goroute(2)">
            <div class="imbook">
              <img src="../assets/p2.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅱ）</div>

            <p class="ptitle">
              正在我国医院推广并普及的图像归档和传输系统PACS/放射医学信息系统RIS能全面、
              有效地解决医学影像的获取、显示、管理、存储和传输等一系列技术问题，
              为此所编写的“医院信息化技术（II）”
            </p>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="lis" @click="goroute(3)">
            <div class="imbook">
              <img src="../assets/p3.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅲ）</div>

            <p class="ptitle">
              远程医学信息会诊系统是信息技术与医学相结合的产物，
              它运用网络通信与计算机多媒体技术为患者提供医学信息和医疗服务。
            </p>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="lis" @click="goroute(4)">
            <div class="imbook">
              <img src="../assets/p4.png" alt />
            </div>
            <div class="title">医院信息化技术（Ⅳ）</div>

            <p class="ptitle">
              信息，指音讯、消息、通讯系统和处理的对象，
              泛指人类社会传播的一切内容。
            </p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="product">
      <div class="protitle">产品信息</div>
      <div class="profal">专业的品牌服务，为您创作更高的价值</div>

      <div class="prolis" v-if="!isMobile">
        <el-carousel :interval="4000" type="card" height="300px">
          <el-carousel-item v-for="(item, index) in cards" :key="index">
            <div
              class="car"
              @click="$router.push(`/chanpindetil?id=` + item.id)"
            >
              <img :src="item.img" alt />
              <div class="flt">{{ item.title }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="shouplis" v-if="isMobile">
        <el-carousel height="350px" arrow="never" ref="card">
          <el-carousel-item v-for="(item, index) in cards" :key="index">
            <div
              class="car"
              @click="$router.push(`/chanpindetil?id=` + item.id)"
            >
              <img :src="item.img" alt />
              <div class="flt">{{ item.title }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="pfol">
          <div class="pl" @click="prev"><i class="el-icon-arrow-left"></i></div>
          <div class="pz" @click="$router.push('/chanpin')">更多</div>
          <div class="pl" @click="next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div :class="isMobile ? 'ust' : 'ustitle'">
      <div class="us_left">
        <img src="../assets/g1.jpg" alt />
      </div>
      <div class="us_right">
        <div class="fz30">公司简介</div>
        <div class="fz14">ABOUT US</div>
        <div class="fz14">让您全方位的了解我们</div>
        <div class="fz14 m30">
          洛克斯医疗是横跨智慧医疗、智慧养老产业领域的国家高新技术企业、
          北京市高新技术企业、中关村高新技术企业，双软认证企业，
          为全国地方及部队医院数字化建设服务近二十年。
        </div>
        <div class="duo" @click="$router.push('/locustitle?id=1')">更多</div>
      </div>
    </div>
    <div class="case">
      <div :class="isMobile ? 'cal' : 'cali'">
        <div class="cli" @click="$router.push('/locusanli?id=1')">
          <div class="cl1">
            <img src="../assets/x1.png" alt />
          </div>
          <div class="cl2">广东省越秀区农林街养老项目</div>
          <div class="cl3">全国智慧健康养老示范点平台</div>
          <div class="cl4" @click="$router.push('/locusanli?id=1')">详情</div>
        </div>
        <div
          class="cli"
          v-show="!isMobile"
          @click="$router.push('/locusanli?id=2')"
        >
          <div class="cl1">
            <img src="../assets/x2.png" alt />
          </div>
          <div class="cl2">广东省越秀区建设街养老项目</div>
          <div class="cl3">市级智慧健康养老示范点平台建设</div>
          <div class="cl4" @click="$router.push('/locusanli?id=2')">详情</div>
        </div>
        <div
          class="cli"
          v-show="!isMobile"
          @click="$router.push('/locusanli?id=3')"
        >
          <div class="cl1">
            <img src="../assets/x3.jpg" alt />
          </div>
          <div class="cl2">广东省荔湾区西村街养老项目</div>
          <div class="cl3">智慧健康养老示范点平台建设</div>
          <div class="cl4" @click="$router.push('/locusanli?id=3')">详情</div>
        </div>
      </div>
    </div>
    <div :class="isMobile ? 'shouxin' : 'xinwen'">
      <div class="x1">新闻中心</div>
      <div class="x1 x2">— NEWS —</div>
      <div class="x1 x2">全新资讯一手掌控</div>
      <div class="xli">
        <div
          class="xls"
          v-for="item in list.list"
          :key="item.id"
          @click="$router.push(`/newdetil?id=` + item.id)"
        >
          <div class="xleft">
            <img :src="userpic + item.id + item.pic" alt />
          </div>
          <div class="xlright">
            <p class="titl">
              {{ item.title }}
            </p>
            <p class="time">{{ item.createtime }}</p>
          </div>
        </div>
      </div>
      <div class="geng" @click="$router.push('/newmeet')">更多新闻</div>
    </div>
  </div>
</template>

<script>
import { http } from "../store/http.js";
export default {
  data() {
    return {
      value: "0",
      imgs: [
        { img: require("../assets/1.jpg") },
        { img: require("../assets/2.jpg") },
        { img: require("../assets/3.jpg") },
        { img: require("../assets/4.jpg") },
        { img: require("../assets/5.jpg") },
        { img: require("../assets/6.jpg") },
      ],
      cards: [
        {
          id: 2,
          img: require("../assets/c1.jpg"),
          title: "LOCUS 医学激光彩色/黑白自助打印系统",
        },
        {
          id: 3,
          img: require("../assets/c2.jpg"),
          title: "LOCUS 触摸屏式医学影像会诊读片系统",
        },
        {
          id: 4,
          img: require("../assets/c3.jpg"),
          title: "LOCUS专业医用液晶系列显示器",
        },
        {
          id: 8,
          img: require("../assets/c4.jpg"),
          title: "LOCUS 医院PACS/RIS医学影像存储与传输系统",
        },
        {
          id: 1,
          img: require("../assets/c5.jpg"),
          title: "LOCUS LD 医学影像纸介质打印系统",
        },
      ],
      list: {},
      userpic: "http://api.chinalocus.com/UploadPath/News/Pic/",
      show: false,
      lists: {},
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.news();
    this.show = true;
    // this.newlist();
  },

  methods: {
    newlist() {
      http("Product/List", this, {
        pageIndex: 1,
        title: "",
        pageSize: 5,
      }).then((res) => {
        // console.log(res);
        this.lists = JSON.parse(res).model;
      });
    },
    beforeEnter(el) {
      el.style.opacity = 0; // 初始状态设置透明度为0
    },
    enter(el, done) {
      el.offsetHeight; // 触发重绘以应用样式更改，例如在动画开始前获取布局信息（可选）
      el.style.transition = "opacity 4s"; // 设置过渡效果的时间等属性
      el.style.opacity = 1; // 目标状态设置透明度为1，开始动画
      done(); // 动画完成后调用done()方法，确保Vue知道动画完成
    },
    leave(el, done) {
      el.style.opacity = 0; // 离开时的状态设置透明度为0，可以自定义离开动画逻辑（可选）
      done(); // 确保调用完成，即使没有复杂的离开动画也可以调用done()。
    },
    prev() {
      this.$refs.card.prev();
    },
    next() {
      this.$refs.card.next();
    },
    goroute(a) {
      this.$router.push({
        name: "booklist",
        query: {
          id: a,
        },
      });
    },
    news() {
      http("News/List", this, {
        pageIndex: 1,
        title: "",
        pageSize: 4,
      }).then((res) => {
        // console.log(res);
        this.list = JSON.parse(res).model;
      });
      // var t = document.getElementById("txt");
      // t.innerHTML = this.content;
    },
  },
};
</script>
<style lang="less" scoped>
.con {
  width: 100%;
  height: 100%;
  background-color: #fcfcfc;
  .el-carousel {
    width: 100%;
    /deep/.el-carousel__container {
      width: 100%;
      min-height: 460px;
      .lunimg {
        width: 100%;
        // height: 100%;
      }
    }
  }
  .lunbo {
    height: 130px;
    /deep/.el-carousel__container {
      height: 130px;
    }
    /deep/.el-carousel__indicators {
      display: none;
      z-index: -1;
    }
    .el-carousel__indicators--horizontal {
      display: none;
    }
  }
  .book {
    width: 65%;
    margin: 20px auto;
    padding: 20px 0;
    .book_top {
      text-align: center;
      .fz30 {
        font-size: 30px;
      }
      .fz14 {
        font-size: 14px;
        color: #707070;
      }
    }
    .book_floot {
      width: 100%;
      overflow: hidden;
      display: flex;
      margin-top: 20px;
      .lis {
        width: 270px;
        cursor: pointer;
        margin: 0 15px;
        .liimg {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .title {
          width: 100%;
          font-size: 15px;
          padding: 20px 0;
          border-bottom: 1px solid #ccc;
        }
        .title:hover {
          color: #5b83ee;
          border-bottom: 1px solid #5b83ee;
        }
        .ptitle {
          margin-top: 10px;
          width: 100%;
          display: -webkit-box;
          display: -moz-box;
          display: box; /* Fallback for non-WebKit browsers */
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .bookzhu {
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    /deep/.el-carousel__container {
      height: 500px;
    }
    /deep/.el-carousel__arrow {
      top: 45%;
      font-size: 24px;
      font-weight: 700;
      background-color: rgba(255, 255, 255, 0.0001);
      color: #626262;
    }
    /deep/.el-carousel__arrow--left {
      left: -10px;
    }
    /deep/.el-carousel__arrow--right {
      right: -10px;
    }
    .lis {
      width: 100%;
      text-align: left;
      // position: relative;
      .imbook {
        width: 100%;
        box-sizing: border-box;
        // position: relative;
        img {
          // position: absolute;
          // left: 50%;
          // transform: translateX(-50%);
          margin-left: 27px;
        }
      }
      .title {
        height: 45px;
        line-height: 45px;
        color: #5b83ee;
        font-size: 16px;
        border-bottom: 1px solid #5b83ee;
        margin-bottom: 20px;
      }
      .ptitle {
        font-size: 13px;
        color: #707070;
      }
    }
  }
  .product {
    width: 100%;
    margin-top: 40px;

    .protitle {
      width: 100%;
      text-align: center;
      font-size: 30px;
    }
    .profal {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #707070;
    }
    .prolis {
      width: 63%;
      margin: 30px auto;
      // .el-carousel__item--card {
      //   // width: 33%;
      // }
      /deep/.el-carousel__container {
        // width: 100%;
        min-height: 400px;
      }
      /deep/.el-carousel__arrow {
        background-color: rgb(82, 80, 80);
        color: #fff;
        font-size: 18px;
      }
      .car {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 320px;
        }
        .flt {
          width: 100%;
          height: 60px;
          line-height: 60px;
          text-align: center;
          font-size: 16px;
        }
      }
    }
    .shouplis {
      width: 100%;
      box-sizing: border-box;
      padding: 20px 30px;
      /deep/.el-carousel__container {
        // width: 100%;
        min-height: 350px;
      }
      .car {
        width: 100%;
        img {
          width: 100%;
        }
        .flt {
          width: 100%;
          padding: 20px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #707070;
        }
      }
      .pfol {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: center;
        div {
          border: 1px solid #707070;
          color: #707070;
          font-size: 14px;
          line-height: 36px;
          height: 36px;
        }
        .pl {
          width: 60px;
        }
        .pz {
          width: 140px;
          margin: 0 20px;
        }
      }
    }
  }
  .ustitle {
    width: 63%;
    margin: 20px auto 50px;
    display: flex;
    flex-wrap: wrap;
    .us_left {
      width: 400px;
      height: 320px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .us_right {
      flex: 1;
      box-sizing: border-box;
      padding-left: 30px;
      text-align: left;
      .fz30 {
        font-size: 30px;
      }
      .fz14 {
        font-size: 14px;
        color: #626262;
        margin-bottom: 20px;
      }
      .m30 {
        margin: 30px 0;
      }
      .duo {
        width: 130px;
        height: 36px;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        border: 1px solid rgb(151, 150, 150);
      }
      .duo:hover {
        background-color: rgb(40, 148, 250);
        color: #fff;
        border: none;
      }
    }
  }
  .ust {
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    .us_left {
      width: 100%;
      // height: 320px;
      img {
        width: 100%;
        // height: 100%;
      }
    }
    .us_right {
      width: 100%;
      box-sizing: border-box;
      // padding-left: 30px;
      // text-align: left;
      .fz30 {
        font-size: 30px;
        text-align: center;
      }
      .fz14 {
        font-size: 14px;
        color: #626262;
        margin-bottom: 20px;
        text-align: center;
      }
      .m30 {
        margin: 30px 0;
        text-align: left;
      }
      .duo {
        width: 130px;
        height: 36px;
        margin: 0 auto;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        border: 1px solid rgb(151, 150, 150);
      }
      .duo:hover {
        background-color: rgb(40, 148, 250);
        color: #fff;
        border: none;
      }
    }
  }
  .case {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px 0;
    .cali {
      width: 63%;
      margin: 30px auto;
      // overflow: hidden;
      display: flex;
      .cli {
        width: 32%;
        height: 450px;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        .cl1 {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .cl2 {
          font-size: 20px;
          margin: 20px 0;
        }
        .cl3 {
          font-size: 14px;
          color: #626262;
        }
        .cl4 {
          width: 60%;
          height: 34px;
          line-height: 34px;
          color: #626262;
          font-size: 12px;
          border: 1px solid #707070;
          background-color: #fff;
          margin: 20px auto;
        }
        .cl4:hover {
          cursor: pointer;
          border: 1px solid rgb(35, 126, 245);
          background-color: rgb(35, 126, 245);
          color: #fff;
        }
      }
      .cli:nth-child(3n) {
        margin-right: 0;
      }
    }
    .cal {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 30px;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .cli {
        width: 290px;
        box-sizing: border-box;
        padding: 0 30px;
        .cl1 {
          width: 100%;
          img {
            width: 100%;
          }
        }
        .cl2 {
          font-size: 20px;
          margin: 20px 0;
        }
        .cl3 {
          font-size: 14px;
          color: #626262;
        }
        .cl4 {
          width: 230px;
          height: 34px;
          line-height: 34px;
          color: #626262;
          font-size: 12px;
          border: 1px solid #707070;
          background-color: #fff;
          margin: 20px auto;
        }
      }
    }
  }
  .xinwen {
    width: 63%;
    margin: 50px auto;
    .x1 {
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .x2 {
      font-size: 14px;
      color: #707070;
      font-weight: normal;
      margin-bottom: 20px;
    }
    .xli {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 50px;
      // justify-content: space-between;
      .xls {
        width: 48%;
        display: flex;
        margin-right: 30px;
        height: 100px;
        cursor: pointer;
        margin-bottom: 30px;
        .xleft {
          width: 160px;
          height: 100%;
          background-color: #fff;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .xlright {
          width: calc(100% - 180px);
          text-align: left;
        }
        p {
          text-align: left;
        }
        .time {
          font-size: 16px;
          color: #707070;
          margin-bottom: 10px;
          margin-top: 15px;
        }
        .titl {
          font-size: 16px;
          font-weight: 500;
          display: -webkit-box;
          display: -moz-box;
          display: box; /* Fallback for non-WebKit browsers */
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .xls:nth-child(2n) {
        margin-right: 0;
      }
      .geng:hover {
        border: none;
        background-color: rgb(61, 121, 252);
        color: #fff;
        cursor: pointer;
      }
    }
    .geng {
      width: 130px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      color: #707070;
      margin: 0 auto;
      border: 1px solid #707070;
      cursor: pointer;
    }
    .geng:hover {
      border: 1px solid rgb(61, 121, 252);
      background-color: rgb(61, 121, 252);
      color: #fff;
      cursor: pointer;
    }
  }
  .shouxin {
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    .x1 {
      width: 100%;
      text-align: center;
      font-size: 30px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .x2 {
      font-size: 14px;
      color: #707070;
      font-weight: normal;
      margin-bottom: 20px;
    }
    .xli {
      width: 100%;
      .xls {
        width: 100%;
        display: flex;
        .xleft {
          width: 100px;
          // height: 75px;
          img {
            width: 100%;
          }
        }
        .xlright {
          flex: 1;
          margin-left: 20px;
          // width: calc(100% - 180px);
          text-align: left;
          .time {
            font-size: 16px;
            color: #707070;
            margin-bottom: 10px;
            margin-top: 15px;
          }
          .titl {
            font-size: 16px;
            font-weight: 500;
            display: -webkit-box;
            display: -moz-box;
            display: box; /* Fallback for non-WebKit browsers */
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .geng {
        width: 130px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #707070;
        margin: 20px auto;
        border: 1px solid #707070;
      }
    }
    .geng {
      width: 130px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      color: #707070;
      margin: 20px auto;
      border: 1px solid #707070;
    }
  }
}
</style>
